import React, { HTMLProps, PropsWithChildren, useMemo } from 'react';
import { Size } from '@ff-os/shared-utils/types/Size';
import { clamp } from 'lodash';
import styles from './ContainAspectRatioWithinSquare.module.scss';

export const ContainAspectRatioWithinSquare = ({
    children, width, height, ...rest
}: Props) => {

    const containerStyle = useMemo(() => {
        return containContentSize(width, height);
    }, [width, height]);

    return (
        <div className={styles.container} {...rest}>
            <div className={styles.ratioContent}>
                <div className={styles.photoContainer} style={containerStyle}>
                    {children}
                </div>
            </div>
        </div>
    );
};

type Props = HTMLProps<HTMLDivElement> & PropsWithChildren<Size>;

const containContentSize = (width: number, height: number) => {
    const aspectRatio = width / height;
    return {
        width: toClampedPercentage(aspectRatio),
        height: toClampedPercentage(1 / aspectRatio)
    };
};

const toClampedPercentage = (ratio: number) => {
    return clamp(ratio, 0, 1) * 100 + '%';
};